<template id="mainfooter">
<footer class="block_group" id="base_footer" style="z-index:-1">
  <!--<div class="footerGrey"><div class="container">
    <div class="row">
      <div class="col-md-2 col-sm-2">
        <div class="footerNav">
          <h5>My Account</h5>
          <ul>
            <li><a href="#">Order History</a></li>
            <li><a href="#">Change personal info</a></li>
            <li><a href="#">Shipping Methods</a></li>
            <li><a href="#">Branch</a></li>
            <li><a href="#">Logout</a></li>
          </ul>
        </div>
      </div>
      <div class="col-md-2 col-sm-2">
        <div class="footerNav">
          <h5>About Us</h5>
          <ul>
            <li><a href="#">Authorized Reseller</a></li>
            <li><a href="#">Change personal info</a></li>
            <li><a href="#">Shipping Methods</a></li>
            <li><a href="#">Branch</a></li>
          </ul>
        </div>
      </div>
      <div class="col-md-3 col-sm-3">
        <div class="footerNav">
          <h5>Subscribe RRS feed</h5>
          <ul>
            <li><a href="#">Latest items</a></li>
            <li><a href="#">Best buy items</a></li>
            <li><a href="#">Shipping Methods</a></li>
            <li><a href="#">Discount items</a></li>
          </ul>
        </div>
      </div>
      <div class="col-md-5 col-sm-5 col-sm-12">
        <div class="footerRightColumn">
          <div class="footerLogo"><img alt="#" src="@/images/footer-logo.png"></div>
          <p class="address">Unit D, 3/F, V Ga Building, 532 Castle Peak Rd, Cheung Sha Wan</p>
          <p class="phoneNumbers">Tel: +852 3165-8845 <span>Fax: +852 2329-0343</span></p>
        </div>
      </div>
    </div>
    <div class="row footerOfferList">
      <div class="col-md-3 col-sm-3 first">
        <div class="offer">
          <div class="offerIcon"> <a href="#"><img src="@/images/free_shoping.png" class="media-object" alt="#"></a> </div>
          <div class="offerDesc">Free shipping <br>
            upon $1 purchase</div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3">
        <div class="offer">
          <div class="offerIcon"> <a href="#"><img src="@/images/free_shoping2.png" class="media-object" alt="#"></a> </div>
          <div class="offerDesc">Discrete packaging</div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3">
        <div class="offer">
          <div class="offerIcon"> <a href="#"><img src="@/images/free_shoping3.png" class="media-object" alt="#"></a> </div>
          <div class="offerDesc">Payment by credit card <br>
            or transfer</div>
        </div>
      </div>
      <div class="col-md-3 col-sm-3">
        <div class="offer">
          <div class="offerIcon"> <a href="#"><img src="@/images/free_shoping4.png" class="media-object" alt="#"></a> </div>
          <div class="offerDesc">As soon as <br>
            same day delivery</div>
        </div>
      </div>
    </div>
  </div></div>-->
  <!--<section class="footerInfo">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-4">
          <div class="footerimg">
            <div class="fblike">
              <div class="fb-like" data-href="https://www.facebook.com/sampsonstore" data-layout="button_count" data-action="like" data-show-faces="false" data-share="true"></div>
            </div>
            <div class="logo"><img src="@/images/logo-footer@2x.png"></div>
          </div>
        </div>
        <div class="col-md-9 col-sm-8">
         <div class="pull-right"> <div class="rightBlock">
            <p>Authorized Reseller</p>
            <ul class="paymentPartnerLogo">
              <li><img src="@/images/auth01.jpg" alt="#"></li>
              <li><img src="@/images/auth02.jpg" alt="#"></li>
              <li><img src="@/images/auth03.jpg" alt="#"></li>
              <li><img src="@/images/auth04.jpg" alt="#"></li>
            </ul>
          </div>
          <div class="rightBlock">
            <p>Payment Partners</p>
            <ul class="paymentPartnerLogo">
              <li><img src="@/images/union.jpg" alt="#"></li>
              <li><img src="@/images/p01.jpg" alt="#"></li>
              <li><img src="@/images/p02.jpg" alt="#"></li>
              <li><img src="@/images/p03.jpg" alt="#"></li>
              <li><img src="@/images/p04.jpg" alt="#"></li>
              <li><img src="@/images/p05.jpg" alt="#"></li>
              <li><img src="@/images/p06.jpg" alt="#"></li>
              <li><img src="@/images/p07.jpg" alt="#"></li>
              <li><img src="@/images/p08.jpg" alt="#"></li>
            </ul>
          </div>
          <div class="rightBlock last">
            <p>&nbsp;</p>
            <ul class="paymentPartnerLogo">
              <li><img src="@/images/img01.jpg" alt="#"></li>
              <li><img src="@/images/img02.jpg" alt="#"></li>
              <li><img src="@/images/img03.jpg" alt="#"></li>
            </ul>
          </div></div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <ul class="footerLinks">
                <li><a href="https://www.sampsonstore.com/neovision/condom/info/terms.is" target="_blank">Terms of Use</a><span>|</span></li>
                <li><a href="https://www.sampsonstore.com/neovision/condom/info/privacy.is" target="_blank">Privicy</a></li>
              </ul>
              <p class="copyRight"><span>Copyright</span> &copy; 2002-2018 SampsonStore.com Ltd. All rights reserved. Designated trademarks and brands are the property of their respective owners.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>-->
  <div class="block_wrapper" id="base_footer_bar">
    <div class="block_container">
      <div class="base">
        <div class="phone">
          <h1>{{footer_text.cs_hotline}}</h1><br>
          <a :href="footer_text.hotline.url">
            <i class="fa fa-phone"></i>
            {{footer_text.hotline.name}}
          </a>
          <a v-for="(val, key, idx) in footer_text.cs" target="_blank" class="btn_cs hover_info" :href="val.url">
            <img class="icn_svg" :src="val.img">
            <div class="info_box" v-html="val.name"></div>
          </a>
<!--
          <a class="btn_cs hover_info" :href="footer_text.line_url">
            <img class="icn_svg" src="@/images/icon-line.svg">
            <div class="info_box">
              <span>{{footer_text.line_cs}}</span>
              <p v-html="footer_text.line_no">+852 9560 0945</p>
            </div>
          </a>
-->
        </div>
        <div class="socialmedia">
          <template v-for="(val, key, idx) in footer_text.socialmedia">
            <a :target="(val.indexOf('http') >= 0)?'_blank':''" :href="val"><i :class="'fa fa-'+key"></i></a>&nbsp;
          </template>
          <!--a><i class="fa fa-tumblr-square"></i></a-->
<!--
          <a target="_blank" href="https://www.facebook.com/sampsonstore"><i class="fa fa-facebook"></i></a>
          <a href="/neovision/condom/contactus/index.is"><i class="fa fa-envelope"></i></a>
-->
        </div>
      </div>
    </div>
  </div>
  <div class="block_wrapper" id="base_footer_legal">
    <div class="block_container">
      <div class="base">
        <div class="legal_logoline" v-if="footer_text.brands || footer_text.pays || footer_text.others">
          <div class="logo_group officialdist" v-if="footer_text.brands != null">
            <label>{{footer_text.authdealer}}</label>
            <template v-for="(val, key, idx) in footer_text.brands"><div :class="'logo '+key"><a v-if="val != null && val.length > 0" target="_blank" :href="val"></a><div v-else></div></div>&nbsp;</template>
<!--
            <div class="logo sagami"><div></div></div>
            <div class="logo pjur"><div></div></div>
            <div class="logo pjur_active"><div></div></div>
            <div class="logo tenga"><div></div></div>
            <div class="logo lelo"><div></div></div>
            <div class="logo onecondoms"><div></div></div>
-->
          </div>
          <div class="logo_group payment" v-if="footer_text.pays != null">
            <label>{{footer_text.paytype}}</label>
            <template v-for="(val, key, idx) in footer_text.pays"><div :class="'logo '+key"><a v-if="val != null && val.length > 0" target="_blank" :href="val"></a><div v-else></div></div>&nbsp;</template>
<!--
            <div class="logo unionpay"><a target="_blank" href="http://www.unionpayintl.com/hk/"></a></div>
            <div class="logo eps"><a target="_blank" href="https://www.eps.com.hk/"></a></div>
            <div class="logo vbv"><a target="_blank" href="http://www.visa.com/"></a></div>
            <div class="logo mc"><a target="_blank" href="http://www.mastercard.com/"></a></div>
            <div class="logo ae"><a target="_blank" href="http://www.americanexpress.com/"></a></div>
            <div class="logo applepay"><a target="_blank" href="https://www.apple.com/apple-pay"></a></div>
            <div class="logo paypal"><a target="_blank" href="https://www.paypal.com/"></a></div>
            <div class="logo alipay"><a target="_blank" href="http://www.alipay.com/"></a></div>
            <div class="logo alipayhk"><a target="_blank" href="https://www.alipayhk.com/"></a></div>
            <div class="logo googlepay"><a target="_blank" href="https://pay.google.com/"></a></div>
            <div class="logo wechatpay"><a target="_blank" href="https://pay.weixin.qq.com/"></a></div>
            <div class="logo payme"><a target="_blank" href="https://payme.hsbc.com.hk/"></a></div>
            <div class="logo fps"><a target="_blank" href="https://fps.hkicl.com.hk"></a></div>
-->
          </div>
          <div v-if="footer_text.others != null" class="logo_group topright"> 
            <template v-for="(val, key, idx) in footer_text.others"><div :class="'logo '+key"><a v-if="val != null && val.length > 0" target="_blank" :href="val"></a><div v-else></div></div>&nbsp;</template>
<!--
            <div class="logo hkreg"><div></div></div>
            <div class="logo caring"><div></div></div>
-->
          </div>
        </div>
        <div class="legal_copyright">
          <a href="/neovision/condom/info/terms.is">{{footer_text.terms}}</a>
          <a href="/neovision/condom/info/privacy.is">{{footer_text.privacy}}</a>
          <p v-html="printCopyRight(footer_text.copyright)"></p>
        </div>
        <div class="fblike" v-if="footer_text.fblike != null">
          <div class="fb-like" :data-href="footer_text.fblike" data-layout="button_count" data-action="like" data-show-faces="false" data-share="true"></div>
        </div>
        <div class="logo_year">
          <div class="logo"><img src="@/images/logo-footer@2x.png"></div>
          <p class="year">{{footer_text.started}}</p>
        </div>
      </div>
    </div>
  </div>

</footer>
</template>

<script>
export default {
  name: 'mainfooter',
  props:['name', 'footer_text'],
  data () {
    return {
    }
  },
  methods: {
    printCopyRight:function(txt) {
      return this.$options.filters.printLine(txt, {'year':new Date().getFullYear()})
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainFooter.vue